import { RoutePaths } from '@shared/utils/route.utils';
import { Navigate, Outlet } from 'react-router-dom';
import { isDevelopment } from '@shared/config/runtime-config';

const UiKitGuard = () => {
  if (!isDevelopment()) {
    return <Navigate to={RoutePaths.Core.Analytics.Orders.absolutePath} />;
  }

  return <Outlet />;
};

export default UiKitGuard;
